import React from 'react';
import { styled } from '@compiled/react';
import { Checkbox } from '@atlaskit/checkbox';
import Heading from '@atlaskit/heading';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import { useIntl } from '@atlassian/jira-intl';
import type { IconsViewConfiguration } from '../../../../services/my-preference/types';
import messages from './messages';

type Props = {
	iconsViewConfiguration: IconsViewConfiguration;
	onChange: (config: IconsViewConfiguration) => void;
};

export const IconsConfiguration = ({ onChange, iconsViewConfiguration }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Heading
				testId="software-deployments.ui.sidebar-content.configuration.icons.title"
				size="xsmall"
			>
				<Title>{formatMessage(messages.title)}</Title>
			</Heading>
			<Checkbox
				testId="software-deployments.ui.sidebar-content.configuration.icons.show-icon-key"
				isChecked={iconsViewConfiguration.showIconKey}
				label={formatMessage(messages.showIconKey)}
				onChange={(e) => {
					const newConfig = {
						...iconsViewConfiguration,
						showIconKey: e.target.checked,
					};
					onChange(newConfig);
				}}
			/>
			<Checkbox
				isChecked={iconsViewConfiguration.showMultipleDeploymentsIcon}
				label={formatMessage(messages.multipleDeploymentsIconLabel)}
				onChange={(e) => {
					const newConfig = {
						...iconsViewConfiguration,
						showMultipleDeploymentsIcon: e.target.checked,
					};
					onChange(newConfig);
				}}
			/>
		</>
	);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Title = styled.div<any>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${gridSize * 3}px`,
	marginTop: 0,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	marginBottom: `${gridSize * 1.25}px`,
});

export default IconsConfiguration;
